<!--
 * @Author: Qzx
 * @LastEditors  : Qzx
 * @Description: 项目内组件模板
 * @Date: 2019-03-15 10:23:00
 * @LastEditTime : 2020-01-02 16:21:34
 -->
<template>
  <div class="locationpicker-container">
    <van-popup v-model="visible" position="bottom">
      <van-picker
        ref="picker"
        :columns="computedColumns"
        @confirm="confirm"
        @change="onLocationChange"
        @cancel="visible = false"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
import area from '../assets/area.json'
export default {
  name: 'locationPicker',
  props: {},
  data () {
    return {
      visible: false,
      provinces: Object.keys(area),
      cities: [],
      counties: []
    }
  },
  created () {
    this.onProvinceChange(['省份', '城市', '区县'])
  },
  computed: {
    computedColumns () {
      return [{ values: this.provinces }, { values: this.cities }, { values: this.counties }]
    }
  },
  methods: {
    onLocationChange (context, values, colIdx) {
      const [provinceIdx, cityIdx] = context.getIndexes()
      switch (colIdx) {
        case 0:
          this.onProvinceChange(values)
          context.setIndexes([provinceIdx, 0, 0])
          break
        case 1:
          this.onCityChange(values)
          context.setIndexes([provinceIdx, cityIdx, 0])
          break
      }
    },
    confirm (value) {
      const [provinceName, cityName, countyName] = value
      const province_id = area[provinceName].val
      const city_id = area[provinceName].items[cityName].val
      const county_id = area[provinceName].items[cityName].items[countyName]
      this.$emit('setLocation', {
        province_id,
        city_id,
        county_id,
        provinceName,
        cityName,
        countyName
      })
      this.visible = false
    },
    onProvinceChange (values) {
      const [provinceName] = values
      this.cities = Object.keys(area[provinceName].items)
      this.counties = Object.keys(area[provinceName].items[this.cities[0]].items)
    },
    onCityChange (values) {
      const [provinceName, cityName] = values
      this.counties = Object.keys(area[provinceName].items[cityName].items)
    },
    initByName (location = ['省份', '城市', '区县']) {
      const [provinceName, cityName, countyName] = location
      // 获取省份index
      const provinceIdx = this.provinces.indexOf(provinceName) || 0
      // 获取城市index
      this.cities = Object.keys(area[provinceName].items)
      const cityIdx = this.cities.indexOf(cityName) || 0
      // 获取区县index
      this.counties = Object.keys(area[provinceName].items[cityName].items)
      const countyIdx = this.counties.indexOf(countyName)
      this.$refs.picker.setIndexes([provinceIdx, cityIdx, countyIdx])
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.locationpicker-container {
  // min-height: 100vh;
  position: absolute;
}
</style>
